import { render, staticRenderFns } from "./AddDeletePeople.vue?vue&type=template&id=58776b68&scoped=true"
import script from "./AddDeletePeople.vue?vue&type=script&lang=ts"
export * from "./AddDeletePeople.vue?vue&type=script&lang=ts"
import style0 from "./AddDeletePeople.vue?vue&type=style&index=0&id=58776b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58776b68",
  null
  
)

export default component.exports